import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { BaseDialog } from '../../base-dialog';

export interface ServiceSuspendedDialogData {
  redirectToPackagesList?: boolean;
  operationName: string;
}

@Component({
  selector: 'mandae-service-suspended-dialog',
  templateUrl: './service-suspended-dialog.component.html',
  styleUrls: ['./service-suspended-dialog.component.scss', '../dialog-shared.scss']
})
export class ServiceSuspendedDialogComponent extends BaseDialog<ServiceSuspendedDialogComponent> {

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: ServiceSuspendedDialogData,
    dialogRef: MatDialogRef<ServiceSuspendedDialogComponent>,
  ) {
    super(dialogRef);
  }

}
